import React, { useState } from 'react';

const SPECIALTIES = [
  { id: 'general', name: 'General Medicine', icon: 'fa-stethoscope' },
  { id: 'cardio', name: 'Cardiology', icon: 'fa-heart-pulse' },
  { id: 'dermato', name: 'Dermatology', icon: 'fa-hand-dots' },
  { id: 'pneumo', name: 'Pulmonology', icon: 'fa-lungs' },
  { id: 'gastro', name: 'Gastroenterology', icon: 'fa-pills' },
  { id: 'neuro', name: 'Neurology', icon: 'fa-brain' },
  { id: 'pediatrie', name: 'Pediatrics', icon: 'fa-baby' },
  { id: 'psychiatrie', name: 'Psychiatry', icon: 'fa-head-side-virus' },
  { id: 'gyneco', name: 'Gynecology', icon: 'fa-venus' },
  { id: 'orl', name: 'ENT', icon: 'fa-ear-listen' },
  { id: 'radio', name: 'Radiology', icon: 'fa-x-ray' },
  { id: 'visio', name: 'Visual Examination', icon: 'fa-eye' },
  { id: 'other', name: 'Other', icon: 'fa-user-doctor' }
];

const CONSULTATION_TYPES = [
  { id: 'initiale', name: 'Initial consultation', icon: 'fa-user-plus' },
  { id: 'suivi', name: 'Follow-up consultation', icon: 'fa-clipboard-list' },
  { id: 'urgence', name: 'Emergency consultation', icon: 'fa-triangle-exclamation' },
  { id: 'teleconsult', name: 'Teleconsultation', icon: 'fa-laptop-medical' },
  { id: 'controle', name: 'Control consultation', icon: 'fa-check-circle' },
  { id: 'preop', name: 'Preoperative consultation', icon: 'fa-hospital-user' },
  { id: 'postop', name: 'Postoperative consultation', icon: 'fa-bandage' }
];

const WelcomeDialog = ({ onSubmit, onClose, initialInfo, isEditing }) => {
  const [doctorName, setDoctorName] = useState(initialInfo?.name || '');
  const [consultationPlace, setConsultationPlace] = useState(initialInfo?.place || '');
  const [doctorSpecialty, setDoctorSpecialty] = useState(initialInfo?.specialty || '');
  const [customSpecialty, setCustomSpecialty] = useState(initialInfo?.customSpecialty || '');
  const [consultationType, setConsultationType] = useState(initialInfo?.consultationType || '');

  const handleSubmit = (e) => {
    e.preventDefault();
    
    const finalSpecialty = doctorSpecialty === 'Other' ? customSpecialty : doctorSpecialty;
    
    if (doctorName.trim() && consultationPlace.trim() && finalSpecialty.trim() && consultationType.trim()) {
      const info = {
        name: doctorName.trim(),
        specialty: doctorSpecialty,
        customSpecialty: customSpecialty.trim(),
        place: consultationPlace.trim(),
        consultationType: consultationType
      };
      
      onSubmit(info);
    }
  };

  const isFormValid = doctorName.trim() && 
                    consultationPlace.trim() && 
                    (doctorSpecialty === 'Other' ? customSpecialty.trim() : doctorSpecialty) && 
                    consultationType.trim();

  return (
    <div className="welcome-overlay">
      <div className="welcome-dialog">
        {isEditing && <button
          type="button"
          className="dialog-close-btn"
          onClick={onClose}
          aria-label="Close"
        >
          <i className="fas fa-times"></i>
        </button>}
        <h1 className="welcome-title">
          {isEditing ? 'Edit information' : 'Welcome to MediScan'}
        </h1>
        <p className="welcome-subtitle">
          {isEditing 
            ? 'Update your consultation information'
            : 'Please fill in your information to start medical transcription'
          }
        </p>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">Physician name *</label>
            <input
              type="text"
              className="form-input"
              value={doctorName}
              onChange={(e) => setDoctorName(e.target.value)}
              placeholder="Dr. Martin Brown"
              required
            />
          </div>

          <div className="form-group">
            <label className="form-label">Medical specialty *</label>
            <div className="specialty-grid">
              {SPECIALTIES.map(specialty => (
                <div
                  key={specialty.id}
                  className={`specialty-option ${doctorSpecialty === specialty.name ? 'selected' : ''}`}
                  onClick={() => setDoctorSpecialty(specialty.name)}
                >
                  <div className="specialty-icon">
                    <i className={`fas ${specialty.icon}`}></i>
                  </div>
                  <div className="specialty-name">{specialty.name}</div>
                </div>
              ))}
            </div>
          </div>

          {doctorSpecialty === 'Other' && (
            <div className="form-group">
              <label className="form-label">Custom specialty *</label>
              <input
                type="text"
                className="form-input"
                value={customSpecialty}
                onChange={(e) => setCustomSpecialty(e.target.value)}
                placeholder="Your specialty"
                required
              />
            </div>
          )}

          <div className="form-group">
            <label className="form-label">Consultation location *</label>
            <input
              type="text"
              className="form-input"
              value={consultationPlace}
              onChange={(e) => setConsultationPlace(e.target.value)}
              placeholder="Medical office, Hospital..."
              required
            />
          </div>

          <div className="form-group">
            <label className="form-label">Consultation type *</label>
            <div className="specialty-grid">
              {CONSULTATION_TYPES.map(type => (
                <div
                  key={type.id}
                  className={`specialty-option ${consultationType === type.name ? 'selected' : ''}`}
                  onClick={() => setConsultationType(type.name)}
                >
                  <div className="specialty-icon">
                    <i className={`fas ${type.icon}`}></i>
                  </div>
                  <div className="specialty-name">{type.name}</div>
                </div>
              ))}
            </div>
          </div>

          <button
            type="submit"
            className="btn-primary"
            disabled={!isFormValid}
            style={{ display: 'block', width: '100%', padding: '14px 24px', fontSize: '16px' }}
          >
            {isEditing ? 'Update' : 'Start transcription'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default WelcomeDialog;